export default __webpack_public_path__ + "static/media/WoWildCraftLogo.f55bc848.png";